export const handleRegistrationScroll = () => {
    document.getElementById("registration")?.scrollIntoView({ behavior: "smooth" });
  };